import { definePreset } from '@primeng/themes';
import Lara from '@primeuix/themes/lara';

export const ThemePreset = definePreset(Lara, {
    semantic: {
        primary: {
            50: 'var(--accent-50)',
            100: 'var(--accent-100)',
            200: 'var(--accent-200)',
            300: 'var(--accent-300)',
            400: 'var(--accent-400)',
            500: 'var(--accent-500)',
            600: 'var(--accent-600)',
            700: 'var(--accent-700)',
            800: 'var(--accent-800)',
            900: 'var(--accent-900)',
            950: 'var(--accent)'
        },
        colorScheme: {
            // light: {
            //     surface: {
            //         0: '#ffffff',
            //         50: '{slate.50}',
            //         100: '{slate.100}',
            //         200: '{slate.200}',
            //         300: '{slate.300}',
            //         400: '{slate.400}',
            //         500: '{slate.500}',
            //         600: '{slate.600}',
            //         700: '{slate.700}',
            //         800: '{slate.800}',
            //         900: '{slate.900}',
            //         950: '{slate.950}'
            //     }
            // }
        }
    },

    components: {
        radiobutton: {
            root: {
                checkedBackground: 'var(--surface)',
            },
            icon: { checkedColor: 'var(--accent)', },
        },
        select: {
            root: {
                background: 'var(--surface)',
                borderColor: 'var(--ink-100)',
                hoverBorderColor: 'var(--ink-300)',
                focusBorderColor: 'var(--accent)',
                invalidBorderColor: 'var(--bad)',
                color: 'var(--ink-800)',
                placeholderColor: 'var(--ink-400)',
                borderRadius: 'var(--radius-sm)',
                paddingX: '16px',
                paddingY: '13px',
                shadow: 'var(--shadow-card)',
                focusRing: {
                    width: '4px',
                    style: 'solid',
                    color: 'var(--accent-50)',
                },
            },
            overlay: {
                background: 'var(--surface)',
                borderColor: 'var(--ink-100)',
                borderRadius: 'var(--radius)',
                shadow: 'var(--shadow-pop)',
            },
            option: {
                selectedBackground: 'var(--accent-50)',
                selectedColor: 'var(--accent-700)',
                selectedFocusBackground: 'var(--accent-50)',
                selectedFocusColor: 'var(--accent-700)',
                focusBackground: 'var(--surface-2)',
                color: 'var(--ink-800)',
                borderRadius: 'var(--radius-sm)',
            },
        }
    }
});